<!--票据打印页面-->
<template>
    <a-card :bordered="false" :class="{'abcdefg':true}">
      <div class="no-print" style="text-align: right;margin-bottom: 20px">
        <a-button v-print="'#printContent'" ghost type="primary">{{ $t('打印') }}</a-button>
      </div>
      <section ref="print" id="printContent" class="print-section">
          <!--
        <div style="text-align: center">
          <p style="font-size: 24px;font-weight: 800">{{ $t('大兴水厂用户缴费收据') }}</p>
        </div>
        -->
        <table border="1" id="table" style="height: 110mm;width:230mm">
            <tr>
            <td colspan="4"><span style="font-size: 20px;font-weight: 800">{{ $t('大兴水厂用户缴费收据') }}</span></td>
          </tr>
          <tr>
            <td>{{ $t('地址') }}</td>
            <td colspan="3">{{model.userAddr}}</td>
          </tr>
          <tr>
            <td>{{ $t('交易时间') }}</td>
            <td>{{model.updateTime?model.updateTime:model.createTime}}</td>
            <td>{{ $t('用户姓名') }}</td>
            <td>{{model.userName}}</td>
            <!--
            <td>{{ $t('订单号') }}</td>
            <td>{{model.payOrderId}}</td>
            -->
          </tr>
          <tr>
              <td>{{ $t('用水性质') }}</td>
            <td>{{model.userPriceName}}</td>
            <td>{{ $t('用户编号') }}</td>
            <td>{{model.meterUserId}}</td>
            
          </tr>
          <tr>
            <td>{{ $t('水费单价(元/m³)') }}</td>
            <td>{{model.userPriceTotal}}</td>
            <td>{{ $t('本次购买量(吨)') }}</td>
            <td>{{model.payWaterNum}}</td>
          </tr>
          <tr>
              <!--
            <td>{{ $t('交易方式') }}</td>
            <td>{{model.userAccountPayType?payType[model.userAccountPayType]: '未知'}}</td>-->
            <td>{{ $t('本次购买金额(元)') }}</td>
            <td>{{model.userPayAccountNum}}</td>
            <td>{{ $t('交易金额(大写)') }}</td>
            <td>{{model.userPayAccountNum|changeToChinese}}</td>
          </tr>
          <tr>
            <td>{{ $t('操作员') }}</td>
            <td colspan="3">
              {{ $t('打印员:') }}{{nickname()}}&nbsp;&nbsp;{{ $t('打印时间:') }}{{moment().format('YYYY-MM-DD HH:mm:ss')}}
            </td>
          </tr>
        </table>
      </section>
    </a-card>
</template>
<script>
import { changeToChinese } from '@/utils/util'
import {isUndefined,isNull} from '@/utils/validate'
import moment from "moment"
import { mapGetters } from 'vuex'
import {payTypeObj} from '@/utils/constants/commonConstant'
export default {
  filters: {changeToChinese},
    props: {
        'model': Object
    },
    data() {
        return {
            visible: false,
            payType: payTypeObj
        }
    },
    methods: {
        moment,
        ...mapGetters(["nickname", "avatar","userInfo"]),
    }
}
</script>
<style>
#table td{text-align: center;}
.print-section{
  color: #000;
}
</style>